import { HTTP_INTERCEPTORS, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { AppConfig } from "src/app/configs/app.config";
// import {} from './'

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private spinner: NgxSpinnerService) {}

  public readonly BASE_API_URL: string = AppConfig.BASE_API_URL;
  public readonly BASE_ADSP_API_URL: string = AppConfig.BASE_ADSP_URL;
  public readonly BASE_BDSP_API_URL: string = AppConfig.BASE_BDSP_URL;
  public readonly BASE_AI_BOT_URL: string = AppConfig.BASE_AI_BOT_URL;

  req_count: number = 0;

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const BASE_URLS = [this.BASE_API_URL, this.BASE_ADSP_API_URL, this.BASE_BDSP_API_URL];
    const excludeArray = [].concat(...BASE_URLS.map(baseUrl => [
      `${baseUrl}/report/report_types/`,
      `${baseUrl}/report/`,
      `${baseUrl}/token/`
    ]));
    excludeArray.push(`${this.BASE_AI_BOT_URL}/chatbot/`);
    function checkExludeurl() {
      let isExlude = [];
      excludeArray.map((item) => {
        const filterBy = new RegExp(
          "^" + `${item}*`.replace(/\*/g, ".*") + "$"
        ).test(req.url);
        isExlude.push(filterBy);
      });
      return isExlude.includes(true);
      // const filterBy = new RegExp(
      //   "^" + `${exclude_url}*`.replace(/\*/g, ".*") + "$"
      // ).test(req.url);
      // let tempurl = req.url;
      // let checkurlID = tempurl.replace(exclude_url, "1").replace("/", "1");
      // const matched = /\d+$/.test(checkurlID);
      // if (filterBy && req.method == "GET" && matched) {
      //   return true;
      // } else {
      //   return false;
      // }
    }

    let isMatched = checkExludeurl();
    if (!isMatched) {
      this.req_count ++;
      this.spinner.show();
    }
    return next.handle(req).pipe(
      finalize(() => {
        if (!isMatched) {
          this.req_count --;
          if(this.req_count == 0) this.spinner.hide();
        }
      })
    );
  }
}
export const LoadingInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: LoadingInterceptor,
  multi: true,
};
